import type { ItemType } from '@/models/item/itemSchema';

import type { GetItemsFilters, ItemsFilters } from './getItems';

export const itemsQueryKey = {
  all: ['items'],
  filters: (filters?: GetItemsFilters) =>
    filters ? [...itemsQueryKey.all, filters] : itemsQueryKey.all,
  paginated: (filters?: ItemsFilters, type?: ItemType) => [
    ...itemsQueryKey.all,
    { filters, type },
  ],
  quickSearch: (query: string) => [...itemsQueryKey.all, 'quicksearch', query],
  detail: (id: string) => [...itemsQueryKey.detailAll, id],
  detailAll: ['item'],
  overview: (type?: ItemType) => [
    ...itemsQueryKey.overviewAll,
    ...(type ? [type] : []),
  ],
  overviewAll: ['item-overview'],
};
